import { render, staticRenderFns } from "./DashboardRabattprozessIcon.vue?vue&type=template&id=1372a2b8&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1372a2b8",
  null
  
)

export default component.exports